export default {
  common: {
    confirm: 'Xác nhận',
    confirmed: 'Đã xác nhận',
    cancel: 'Hủy',
    select: 'Hãy chọn',
    search: 'Tìm kiếm',
    notice: 'Lưu ý',
    confirmRole: 'Xác nhận thông tin nhân vật',
    announce: 'Thông Báo',
    currency: '₫'
  },
  pay: {
    title: {
      SelectCharacter: 'Chọn nhân vật',
      SelectBundle: 'Chọn mua vật phẩm',
      game: 'Game',
      gamePlaceholder: 'Hãy chọn game',
      server: 'Server',
      serverPlaceHolder: 'Hãy chọn server',
      role: 'Nhân vật',
      rolePlaceHolder: 'Hãy chọn nhân vật'
    },
    instructions: {
      title: 'Hướng Dẫn Nạp Tiền',
      subtext: 'Hướng Dẫn Dịch Vụ',
      paragraph1: '1. Để bảo đảm quyền lợi của bạn, hãy đọc kỹ thông tin chi tiết gói nạp trước khi mua.',
      paragraph2:
        '2. Dịch vụ này chỉ dành cho người dùng đã tạo nhân vật trong game. Người dùng chưa tạo nhân vật sẽ không thể tìm thấy thông tin server, nhân vật trên trang này, hãy xác nhận thông tin nhân vật trước khi nạp.',
      paragraph3:
        '3. LƯU Ý QUAN TRỌNG: Sau khi nhập Server, ID nhân vật, vui lòng kiểm tra kỹ thông tin nhân vật của tài khoản, xác nhận chính xác rồi mới tiến hành bước tiếp theo!',
      paragraph4:
        '4. Sau khi thanh toán thành công, vật phẩm mua qua trang này sẽ được gửi vào tài khoản game của bạn qua thư hệ thống. Nếu sau 30 phút nạp thành công vẫn chưa nhận được vật phẩm, có thể liên hệ CSKH qua nút hỗ trợ nổi trong game để phản ánh, chúng tôi sẽ kịp thời giải quyết vấn đề cho bạn.',
      paragraph5:
        '5. Thời gian nhận gói nạp có thể thay đổi do độ trễ đường truyền mạng, trạng thái nhận thực tế vui lòng căn cứ theo hiển thị trong game. Nếu có thắc mắc, hãy liên hệ nhân viên CSKH để được giải đáp.'
    },
    Region: 'Cụm',
    Server: 'Server',
    ServerPlaceholder: 'Server (Nhấn để tìm)',
    CharacterID: 'ID nhân vật',
    CharacterName: 'Tên nhân vật',
    RoleName: 'Tên nhân vật',
    bundelDetails: 'Chi tiết vật phẩm',
    protocal: {
      services: 'Thỏa thuận người dùng',
      policy: 'Chính sách bảo mật',
      address: 'Số 23 Lê Thị Riêng, Phường Bến Thành, Quận 1, Thành phố Hồ Chí Minh',
      ysAddress: 'ward 7, North Jhagrakhand , maharana pratap ward, manendragarh, koriya, chhattisgarh Manendragarh - 497446',
    },
    dialogMessage: {
      reenter: 'Hãy nhập lại thông tin nhân vật',
      selectServer: 'Hãy liên kết nhân vật trước',
      selectRoleId: 'Hãy liên kết nhân vật trước',
      fillCharacterID: 'Hãy nhập ID nhân vật',
      confirmCharacter: 'Hãy xác nhận thông tin nhân vật'
    },
    footer: {
      safe: {
        title: 'An Toàn',
        subTitle: 'Trung tâm thanh toán chính thức'
      },
      convenient: {
        title: 'Tiện Lợi',
        subTitle: 'Thêm nhanh vào giỏ, thanh toán tiện lợi'
      },
      economical: {
        title: 'Ưu Đãi',
        subTitle: 'Hoàn trả siêu hời'
      },
      efficient: {
        title: 'Nhanh Chóng',
        subTitle: 'Nhận ngay tức thì, không độ trễ'
      }
    },
    announce: {
      type: 'Hoạt Động'
    }
  },
  paySubmit: {
    paymenMethod: 'Phương thức thanh toán',
    prodDetails: 'Chi tiết vật phẩm',
    discount: 'Giảm giá',
    discountCode: 'Mã giảm giá',
    submit: 'Xác nhận',
    total: 'Tổng cộng',
    fillDiscountCode: 'Hãy nhập mã giảm giá',
    protocal: 'Đã đọc quy định vận hành và xác nhận giá vật phẩm và đạo cụ',
    agree: 'Hãy đồng ý với thỏa thuận',
    currentRegion: 'Khu vực hiện tại',
    paymentMethods: 'Phương thức thanh toán',
    items: 'Vật phẩm'
  }
};
